import { Box, Grid, FormControl,FormLabel } from "@mui/material";
import { useCallback, useState, useEffect } from 'react';
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../bmr/components/common/FormikControl";
import { useDispatch, useSelector } from "react-redux";
import { addPaymentStatusValidationSchema } from "../../../utils/formik/validationSchema"
import { modeOfPaymentStatus } from "../../../bmr/slices/help"
import {SUPPORTED_FORMATS} from "../../../pages/appointment-details/common-pre-screen/common"
import {handleDownload} from "../../../bmr/constants/constant"
import  FileUploadComponent from '../../../bmr/pages/FeasibilityAssessment/BMRSlots/FileUploadComponent'
import { selectDropDownDataMaster, fetchManufecturingButtonDropDown } from "../../../bmr/slices/customMaster"

const AddUpdatePayment = ({ editData={}, feasiblityId, handleCloseModal={},productManufacturingId }) => {
    const dispatch = useDispatch()
    const PaymentStatusList = useSelector(selectDropDownDataMaster('payment'))
    const [isLoading, setIsLoading] = useState(false) 
    useEffect(() => {
        dispatch(fetchManufecturingButtonDropDown('payment'))
    }, [])
    const mappedMedia = (editData?.payment_media || []).map((mediaItem) => {
        if (mediaItem?.media_details) {
            return {
                id: mediaItem?.media_details?.id ?? mediaItem?.media_id ?? mediaItem?.id,
                file_name: mediaItem?.media_details?.file_name ?? mediaItem?.file_name,
                file_path: mediaItem?.media_details?.file_path ?? mediaItem?.file_path,
            };
        } else {
            return {
                id: mediaItem?.id ?? mediaItem?.media_id,
                file_name: mediaItem?.file_name,
                file_path: mediaItem?.file_path,
            };
        }
    });

    const initialValue = {
        payment_status: editData?.payment_status
            ? (() => {
                const statusVal = typeof editData.payment_status === 'object'
                    ? (editData.payment_status.id || editData.payment_status.name)
                    : editData.payment_status;
                return (
                    PaymentStatusList?.find((it) => it?.value?.toString() === statusVal?.toString()) ??
                    PaymentStatusList?.find((it) => it?.label?.toLowerCase() === statusVal?.toString()?.toLowerCase())
                )?.value ?? statusVal;
              })()
            : '',
        media: mappedMedia,
        media_id: mappedMedia.map((mediaItem) => mediaItem.id).filter(Boolean),
        remarks: editData?.remarks ?? '',
    };

      const handleModelSubmit = useCallback(async(values) => {
         setIsLoading(true)
              try {
                  const currentMediaIds = (values.media || [])
                      .map((it) => it?.id ?? it?.media_id)
                      .filter((id) => id !== undefined && id !== null)
                        const data = {
                            id: feasiblityId,
                            data: {
                                ...values,
                                  media_id: currentMediaIds,
                             product_manufacturing_id:productManufacturingId,
                            }
                        }
                  await dispatch(modeOfPaymentStatus(data)).unwrap();
                  handleCloseModal(true);
                    } catch (err) {
                        console.error(err);
                    }
                     finally {
            setIsLoading(false)  
        }
            },[feasiblityId, productManufacturingId, dispatch, handleCloseModal])

    
    const formik = useFormik({
        initialValues:initialValue,
       validationSchema:addPaymentStatusValidationSchema,
        onSubmit:handleModelSubmit,
        enableReinitialize: true
    })

   const formOptions = [
  {
    type: "select",
    name: "payment_status",
    label: "Payment Status",
    placeholder:"Select Payment Status",
    options: PaymentStatusList,
    required: true
  },
{
    label: "Select Attachment",
    type: "file",
    name: "media_id",
    multiple: true,
    removeButton: false,
    acceptFormat: SUPPORTED_FORMATS,
    downloadFile: handleDownload,
    placeholder: "Select a File",
    required: false,
    col: 1,
},
{
    type: "textarea",
    name: "remarks",
    label: "Remarks",
    placeholder: "Enter Remarks",
    required: true,
}
];

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2} className="mb-3">
                    {formOptions.map((props, key) => (
                        <Grid key={key} item xs={12}>
                               {props?.type === 'file' ? (
                                            <FormControl variant="standard" fullWidth>
                                                <FormLabel shrink required={props.required} className="text-black">
                                                  {props.label}
                                                </FormLabel>
                                                 <FileUploadComponent 
                                                field={props}
                                                value={formik?.values[props.name]}
                                                 formData={{media: formik.values?.media,media_id: formik.values?.media_id }}   // MUST be an object
                                        setFormData={(cb) => {
                                            const newState = cb({
                                                media: formik.values.media,
                                                media_id: formik.values.media_id
                                            });
                                            formik.setValues(prev => ({
                                                ...prev,
                                                media: newState.media,
                                                media_id: newState.media_id,
                                            }));
                                        }}
                                                // handleCloseModal={handleCloseModal}
                                                error={formik?.errors[props.name]}
                                                touched={formik?.touched[props.name]}
                                              />
                                            </FormControl>):
                            <FormikControl formik={formik} {...props} />}
                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={2} className="mt-3">
                    <Grid item xs={12}>
                        <LoadingButton  fullWidth type="submit" variant="contained"loading={isLoading}
                            disabled={isLoading} >{editData ? "Update" : "Submit"}</LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}

export default AddUpdatePayment;